module.exports = __webpack_public_path__ + "img/23.24b4c06d.png";